var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264,112h112c4.4,0,8,3.6,8,8v40H256v-40C256,115.6,259.6,112,264,112z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208,124.8v30.4c0,2.7-2.1,4.8-4.8,4.8h-70.4c-38,0-68.8,30.8-68.8,68.8v86.4c0,2.7,2.1,4.8,4.8,4.8h502.4 c2.7,0,4.8-2.2,4.8-4.8v-86.4c0-38-30.8-68.8-68.8-68.8h-70.4c-2.7,0-4.8-2.1-4.8-4.8v-30.4c0-33.6-27.2-60.8-60.8-60.8H268.8 C235.2,64,208,91.2,208,124.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M571.2,368H384v16c0,17.7-14.3,32-32,32h-64c-17.7,0-32-14.3-32-32v-16H64v112c0,35.3,28.7,64,64,64h384 c35.3,0,64-28.7,64-64V372.8C576,370.2,573.8,368,571.2,368z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseSolidFull);
export default __webpack_public_path__ + "static/media/briefcase-solid-full.662382737ed9a3b325ae75645e8a1e2e.svg";
export { ForwardRef as ReactComponent };